import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { Spin } from 'antd';
import { useQuery } from '@apollo/client';

import Filters from '../Filters/Filters';
import LinearChart from '../LinearChart/LinearChart';
import { ChartDataType, StatisticsFiltersType, SubmitFiltersType } from '../types';
import { GetStatisticsFiltersQuery, GetStatisticsQuery, GetStatisticsQueryVariables } from '../../../graphql/codegen/graphql';
import { getStatistics } from '../../../graphql/queries/statistics';
import styles from './Scraped.module.scss';

type FiltersType = {
  frequency?: Array<string>;
  scrapers?: Array<string>;
  tags?: Array<string>;
};

type Props = {
  filters: GetStatisticsFiltersQuery;
};

const Scraped: React.FC<Props> = ({ filters }) => {
  const defaultFilters = {
    startDate: moment().subtract(60, 'days'),
    endDate: moment(),
    frequency: filters.statisticsFilters?.frequency?.data?.[ 1 ],
    scrapers: filters.statisticsFilters?.scrapers?.data,
  };
  const [ parsedFilters, setParsedFilters ] = useState<StatisticsFiltersType>();
  const [ parsedData, setParsedData ] = useState<ChartDataType[]>([]);
  const [ chosenFilters, setChosenFilters ] = useState<GetStatisticsQueryVariables>({
    ...defaultFilters,
    startDate: defaultFilters.startDate.format('YYYY-MM-DD'),
    endDate: defaultFilters.endDate.format('YYYY-MM-DD'),
  });

  const { data, loading } =
    useQuery<GetStatisticsQuery, GetStatisticsQueryVariables>(getStatistics, {
      variables: chosenFilters,
    });

  useEffect(()=> {
    setParsedFilters({
      frequency: {
        type: filters.statisticsFilters?.frequency?.type,
        data: filters.statisticsFilters?.frequency?.data,
        defaultValue: defaultFilters.frequency,
      },
      scrapers: {
        type: filters.statisticsFilters?.scrapers?.type,
        data: filters.statisticsFilters?.scrapers?.data,
        defaultValue: defaultFilters.scrapers,
      },
    } as StatisticsFiltersType);
  }, [ filters ]);

  useEffect(()=> {
    if (data) {
      setParsedData(data?.statistics?.scrapped?.map((scraper)=> {
        return {
          id: scraper?.scraperName,
          sum: scraper?.sum,
          data: scraper?.data?.map((item) => {
            return {
              x: item?.dateTime,
              y: item?.total,
            };
          }),
        };
      }) as ChartDataType[]);
    }
  }, [ data ]);

  const {
    control,
    handleSubmit,
  } = useForm<FiltersType>();

  const onSubmit = handleSubmit(({ frequency, scrapers, dates }: SubmitFiltersType) => {
    setChosenFilters({
      frequency,
      scrapersName: scrapers,
      startDate: dates[ 0 ].format('YYYY-MM-DD'),
      endDate: dates[ 1 ].format('YYYY-MM-DD'),
    });
  });

  return (
    <Spin
      spinning={ loading || !parsedFilters || !parsedData }
      tip="Loading..."
      delay={ 500 }
      size="large"
    >
      { parsedFilters && parsedData && (
        <div className={ styles.statsCard }>
          <Filters
            filters={ parsedFilters }
            defaultDates={ [ defaultFilters.startDate, defaultFilters.endDate ] }
            onSubmit={ onSubmit }
            control={ control }
          />
          <LinearChart header="Scraped" data={ parsedData }/>
        </div>
      )}
    </Spin>
  );
};

export default Scraped;
